// © Microsoft Corporation. All rights reserved.
/** The AppType enum. */
export var AppType;
(function (AppType) {
    AppType[AppType["MMX"] = 0] = "MMX";
    AppType[AppType["Edge"] = 1] = "Edge";
    AppType[AppType["EdgeChromium"] = 2] = "EdgeChromium";
    AppType[AppType["FirstParty"] = 3] = "FirstParty";
    AppType[AppType["MicrosoftNews"] = 4] = "MicrosoftNews";
    AppType[AppType["Office"] = 5] = "Office";
    AppType[AppType["Hub"] = 6] = "Hub";
    AppType[AppType["Unknown"] = 7] = "Unknown";
    AppType[AppType["Views"] = 8] = "Views";
    AppType[AppType["SuperApp"] = 9] = "SuperApp";
    AppType[AppType["Windows"] = 10] = "Windows";
    AppType[AppType["Homepage"] = 11] = "Homepage";
    AppType[AppType["WindowsShell"] = 12] = "WindowsShell";
    AppType[AppType["NewsAndInterests"] = 13] = "NewsAndInterests";
    AppType[AppType["WindowsNewsPlus"] = 14] = "WindowsNewsPlus";
})(AppType || (AppType = {}));
/** The AudienceMode enum. */
export var AudienceModeType;
(function (AudienceModeType) {
    AudienceModeType["Enterprise"] = "enterprise";
})(AudienceModeType || (AudienceModeType = {}));
/** The PageType enum */
export var PageType;
(function (PageType) {
    PageType[PageType["MMX"] = 0] = "MMX";
    PageType[PageType["DHP"] = 1] = "DHP";
    PageType[PageType["NTP"] = 2] = "NTP";
    PageType[PageType["WindowsHP"] = 3] = "WindowsHP";
    PageType[PageType["NewsBar"] = 4] = "NewsBar";
    PageType[PageType["Unknown"] = 5] = "Unknown";
})(PageType || (PageType = {}));
/** The WebWorkerMessageId enum. */
export var WebWorkerMessageId;
(function (WebWorkerMessageId) {
    WebWorkerMessageId["AppAnonCookie"] = "appanoncookie";
    WebWorkerMessageId["MyFeed"] = "myfeed";
    WebWorkerMessageId["AuthToken"] = "AuthToken";
    WebWorkerMessageId["UpdateMyFeed"] = "updatemyfeed";
    WebWorkerMessageId["RefreshConfigs"] = "refreshconfigs";
    WebWorkerMessageId["DetectConfigChanges"] = "detectconfigchanges";
    WebWorkerMessageId["ClearConfigCache"] = "clearconfigcache";
    WebWorkerMessageId["Updatepdp"] = "updatepdp";
    WebWorkerMessageId["WeatherPdp"] = "weatherpdp";
    WebWorkerMessageId["MoneyPdp"] = "moneypdp";
    WebWorkerMessageId["LocalNews"] = "localnews";
    WebWorkerMessageId["SportsTeamPdp"] = "sportsteampdp";
    WebWorkerMessageId["SportsPlayerPdp"] = "sportsplayerpdp";
    WebWorkerMessageId["SportsLeaguePdp"] = "sportsleaguepdp";
    WebWorkerMessageId["PerfMarkers"] = "perfmarkers";
    WebWorkerMessageId["ContentPreviewData"] = "ContentPreviewData";
    WebWorkerMessageId["ContentPreviewCache"] = "ContentPreviewCache";
    WebWorkerMessageId["PostTtvr"] = "PostTtvr";
    WebWorkerMessageId["FeedDisplaySetting"] = "FeedDisplaySetting";
    WebWorkerMessageId["WebWorkerError"] = "WebWorkerError";
    WebWorkerMessageId["InvalidateWeatherPdp"] = "InvalidateWeatherPdp";
    WebWorkerMessageId["StripeMyFeed"] = "StripeMyFeed";
    WebWorkerMessageId["UpdateMyBriefing"] = "UpdateMyBriefing";
    WebWorkerMessageId["MyBriefing"] = "MyBriefing";
    WebWorkerMessageId["WindowsFeed"] = "WindowsFeed";
    WebWorkerMessageId["ViewsData"] = "ViewsData";
    WebWorkerMessageId["ViewsDataFetch"] = "ViewsDataFetch";
    WebWorkerMessageId["IndustryNewsArticles"] = "IndustryNewsArticles";
    WebWorkerMessageId["RenderSingleColumn"] = "RenderSingleColumn";
})(WebWorkerMessageId || (WebWorkerMessageId = {}));
/** The all environments. */
export const allEnvironments = {
    prod: {
        domain: "https://www.msn.com"
    },
    int1: {
        domain: "https://int1.msn.com"
    },
    int: {
        domain: "https://int.msn.com"
    },
    intPR: {
        domain: "https://int.msn.com"
    },
    intPef: {
        domain: "https://int.msn.com"
    }
};
/** The Experience Types enum */
export var ExperienceTypes;
(function (ExperienceTypes) {
    ExperienceTypes["ContentPreview"] = "contentpreview";
    ExperienceTypes["River"] = "river";
    ExperienceTypes["EntryPointEdgeNext"] = "entrypointedgenext";
    ExperienceTypes["EntryPoint"] = "entrypoint";
    ExperienceTypes["IndustryNewsCard"] = "industrynewscard";
    ExperienceTypes["PlacementManager"] = "placementmanager";
    ExperienceTypes["WeatherCard"] = "weathercard";
    ExperienceTypes["MyBriefing"] = "mybriefrivercard";
    ExperienceTypes["NewsbarFeed"] = "newsbarfeed";
    ExperienceTypes["DesktopFeed"] = "desktopfeed";
    ExperienceTypes["DesktopFeedEdgeNext"] = "desktopfeededgenext";
    ExperienceTypes["DesktopFeedSingleColumn"] = "desktopfeedsinglecolumn";
})(ExperienceTypes || (ExperienceTypes = {}));
export const ocidMapping = {
    [PageType.MMX]: "EMMX",
    [PageType.DHP]: "spartan-dhp-feeds",
    [PageType.NTP]: "spartan-ntp-feeds"
};
export const scnMapping = {
    [PageType.MMX]: "APP_ANON",
    [PageType.DHP]: "APP_ANON",
    [PageType.NTP]: "APP_ANON",
    [PageType.WindowsHP]: "ANON",
    [PageType.NewsBar]: "APP_ANON"
};
export var RiverConfigType;
(function (RiverConfigType) {
    RiverConfigType["MyFeed"] = "MyFeed";
    RiverConfigType["StripeMyFeed"] = "StripeMyFeed";
})(RiverConfigType || (RiverConfigType = {}));
export var MessageType;
(function (MessageType) {
    MessageType["Data"] = "data";
    MessageType["Command"] = "command";
    MessageType["Subscription"] = "subscription";
})(MessageType || (MessageType = {}));
//# sourceMappingURL=Constants.js.map